import { render, staticRenderFns } from "./SpecialAdd.vue?vue&type=template&id=2c5824e6"
import script from "./SpecialAdd.vue?vue&type=script&lang=js"
export * from "./SpecialAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports